import React from 'react';
import { motion } from 'framer-motion';
import type { Integration } from './types';

interface IntegrationCardProps {
  integration: Integration;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  integration
}) => {
  const isConnected = integration.status === 'connected';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="relative rounded-xl p-3 hover:border-opacity-30 transition-all h-full flex flex-col overflow-hidden"
      style={{
        backdropFilter: 'blur(10px)',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 14px 0px',
        background: '#2a2a2a',
        border: '1px solid rgba(224, 224, 224, 0.13)'
      }}
    >
      {/* Coming Soon Ribbon */}
      {integration.comingSoon && (
        <div className="absolute top-4 -right-10 transform rotate-45 py-1 px-12 text-xs font-bold text-white z-10"
          style={{
            background: 'linear-gradient(90deg, #EE4423, #FF7A59)',
            boxShadow: '0 2px 8px rgba(238, 68, 37, 0.4)'
          }}
        >
          COMING SOON
        </div>
      )}

      {/* Connected Badge */}
      {isConnected && !integration.comingSoon && (
        <div className="absolute top-4 right-4">
          <span className="px-3 py-1 bg-[#ee4425] text-gray-200 text-[10px] font-normal rounded-full ">
            Connected
          </span>
        </div>
      )}

      {/* Icon */}
      <div 
        className="w-10 h-10 rounded-xl flex items-center justify-center mb-4"
        style={{ backgroundColor: `${integration.color}15` }}
      >
        <div style={{ color: integration.color }} className="text-2xl">
          {integration.icon}
        </div>
      </div>

      {/* Name */}
      <h3 className="text-md font-semibold text-white mb-2">
        {integration.name}
      </h3>

      {/* Description */}
      <p className="text-gray-400 text-[12px] leading-relaxed mb-6 flex-grow">
        {integration.description}
      </p>

      {/* Coming Soon Button */}
      {/* {integration.comingSoon && (
        <div className="text-center py-3 rounded-lg border-2 border-gray-600 bg-gray-800">
          <span className="text-gray-400 text-sm font-medium">Coming Soon</span>
        </div>
      )} */}
    </motion.div>
  );
};

export default IntegrationCard;
